(function () {
  'use strict';

  const dests = window.gcDests || [];
  const cfg   = window.gcCalcConfig || { seaThreshold: 1, airThreshold: 45, locale: 'es', disclaimer: { es: '', en: '' } };

  const DEFAULT_DISC = {
    es: 'El costo presentado es una estimación referencial basada en las tarifas de flete vigentes. El precio definitivo se confirma al formalizar la operación, considerando las condiciones exactas del envío, el peso verificado de la mercancía, los requisitos aduaneros del país de destino y los costos locales aplicables. Los precios no incluyen seguros ni transporte interno en China desde el proveedor hasta el puerto.',
    en: 'The cost shown is a referential estimate based on current freight rates. The final price is confirmed upon closing the deal, considering the exact shipping conditions, verified cargo weight, customs requirements of the destination country, and applicable local costs. Prices do not include insurance, import duties, customs fees, or inland transportation in China from the supplier to the port.'
  };

  const lang        = cfg.locale === 'en' ? 'en' : 'es';
  const disclaimer  = (lang === 'en' ? cfg.disclaimer.en : cfg.disclaimer.es) || DEFAULT_DISC[lang];

  const discEl = document.getElementById('gc-disclaimer-text');
  if (discEl) discEl.textContent = disclaimer;

  /* UI strings come from theme locale keys (sections.gc_calc.*); Spanish fallbacks if missing */
  const T = Object.assign({
    welcome: 'Bienvenido/a,', box: 'Caja', remove: 'Eliminar', height: 'Alto (cm)', width: 'Ancho (cm)', length: 'Largo (cm)', weight_kg: 'Peso (kg)',
    method_sea_name: 'Carga Marítima', method_air_name: 'Carga Aérea',
    alert_destination: 'Por favor selecciona un destino de envío.', alert_quantity: 'Por favor ingresa las dimensiones o el peso de tu mercancía.',
    rate: 'tarifa', summary_method: 'Método:', summary_origin: 'Origen:', summary_destination: 'Destino:', summary_volume: 'Volumen:',
    summary_chargeable: 'Peso facturable:', summary_goods: 'Mercancía:', origin_port: 'Puerto de Guangdong, China',
    error_modal_title: 'Enviar Solicitud de Cotización', error_modal_subtitle: 'Recibiremos tu solicitud de inmediato y te enviaremos una cotización personalizada pronto.',
    preview_pending: 'Solicitud: cotización pendiente', preview_summary: 'Resumen de cotización', preview_status: 'Estado',
    preview_manual: 'Tarifa no configurada, requiere cotización manual', preview_cost: 'Costo estimado', preview_transit: 'Tránsito',
    phone_other: 'Otro', sending: 'Enviando…', send: 'Enviar Solicitud'
  }, window.gcCalcI18n || {});

  const METHOD_NAMES    = { sea: T.method_sea_name, air: T.method_air_name };
  /* The internal quote email to the Galium team always stays in Spanish */
  const METHOD_NAMES_ES = { sea: 'Carga Marítima', air: 'Carga Aérea' };

  let state = {
    method: 'sea',
    destId: null,
    tab: 'dimensions',
    weightUnit: 'kg',
    boxes: [{ h: '', w: '', d: '', wt: '' }]
  };

  let calcResult   = null;
  let isErrorState = false;
  let customer     = { name: '', email: '' };

  /* ---- Helpers ---- */
  function cbm(h, w, d) { return ((parseFloat(h)||0)*(parseFloat(w)||0)*(parseFloat(d)||0))/1e6; }
  function volKg(h, w, d) { return ((parseFloat(h)||0)*(parseFloat(w)||0)*(parseFloat(d)||0))/6000; }
  function fmtCBM(v) { return v.toFixed(3)+' m³'; }
  function fmtUSD(v) { return '$'+Math.round(v).toLocaleString('en-US')+' USD'; }
  function $id(id) { return document.getElementById(id); }
  function getDestination() { return dests.find(d => d.id === state.destId) || null; }
  function finalRate(cost, margin) { return cost * (1 + margin / 100); }

  function isPriceConfigured(dest, method, qty) {
    const r = dest[method];
    const threshold = method === 'air' ? cfg.airThreshold : cfg.seaThreshold;
    const cost = qty < threshold ? r.costUnder : r.costOver;
    return cost > 0;
  }

  /* ---- Pre-step ---- */
  $id('gc-prestep-btn').addEventListener('click', function () {
    const nameEl  = $id('gc-cust-name');
    const emailEl = $id('gc-cust-email');
    const name    = nameEl.value.trim();
    const email   = emailEl.value.trim();

    if (!name) {
      nameEl.focus();
      nameEl.style.borderColor = '#c0392b';
      return;
    }
    if (!email || !email.includes('@') || !email.includes('.')) {
      emailEl.focus();
      emailEl.style.borderColor = '#c0392b';
      return;
    }

    nameEl.style.borderColor = '';
    emailEl.style.borderColor = '';
    customer = { name, email };

    /* Unlock calculator and update UI first — before any potentially-failing code */
    $id('gc-calc-main').classList.remove('gc-calc-locked');
    $id('gc-prestep-card').classList.add('gc-prestep-done');
    var btn = $id('gc-prestep-btn');
    btn.innerHTML = T.welcome + ' ' + name.split(' ')[0] + ' &nbsp;&#10003;';
    btn.disabled = true;
    nameEl.readOnly  = true;
    emailEl.readOnly = true;

    setTimeout(function () {
      $id('gc-calc-main').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 200);

    /* Silently subscribe to Shopify newsletter — wrapped so any failure never blocks the above */
    try {
      var subForm = $id('gc-subscribe-form');
      if (subForm) {
        var subEmail = $id('gc-sub-email');
        var subFname = $id('gc-sub-fname');
        var subLname = $id('gc-sub-lname');
        if (subEmail) subEmail.value = email;
        var parts = name.split(' ');
        if (subFname) subFname.value = parts[0] || '';
        if (subLname) subLname.value = parts.slice(1).join(' ') || '';
        var fd = new FormData(subForm);
        fetch(subForm.action, { method: 'POST', body: fd, redirect: 'manual' }).catch(function(){});
      }
    } catch(e) {}
  });

  /* ---- Render destination buttons ---- */
  function renderDests() {
    var grid = $id('gc-dest-grid');
    if (!grid) return;
    grid.innerHTML = '';
    dests.forEach(function (d) {
      var btn = document.createElement('button');
      btn.className = 'gc-dest-btn';
      btn.dataset.destId = d.id;
      btn.type = 'button';
      btn.innerHTML = '<span class="gc-dest-flag">'+d.flag+'</span><span>'+d.city+', '+d.country+'</span>';
      btn.addEventListener('click', function () {
        state.destId = d.id;
        document.querySelectorAll('.gc-dest-btn').forEach(function(x){ x.classList.remove('active'); });
        btn.classList.add('active');
      });
      grid.appendChild(btn);
    });
  }

  /* ---- Method ---- */
  function setMethod(m) {
    state.method = m;
    document.querySelectorAll('.gc-method-btn').forEach(function(b){ b.classList.toggle('active', b.dataset.method === m); });
    var isAir = m === 'air';
    document.querySelector('[data-tab="dimensions"]').style.display = isAir ? 'none' : '';
    document.querySelector('[data-tab="cbm"]').style.display        = isAir ? 'none' : '';
    document.querySelector('[data-tab="weight"]').style.display     = isAir ? '' : 'none';
    $id('gc-chargeable-row').style.display = isAir ? '' : 'none';
    if (isAir)                              switchTab('weight');
    if (!isAir && state.tab === 'weight')   switchTab('dimensions');
    renderBoxes();
  }

  document.querySelectorAll('.gc-method-btn').forEach(function(b){
    b.addEventListener('click', function(){ setMethod(b.dataset.method); });
  });

  /* ---- Tabs ---- */
  function switchTab(tab) {
    state.tab = tab;
    document.querySelectorAll('.gc-calc-tab').forEach(function(b){ b.classList.toggle('active', b.dataset.tab === tab); });
    document.querySelectorAll('.gc-tab-panel').forEach(function(p){ p.classList.add('gc-panel-hidden'); });
    $id('gc-panel-'+tab).classList.remove('gc-panel-hidden');
    recalcTotals();
  }
  document.querySelectorAll('.gc-calc-tab').forEach(function(b){
    b.addEventListener('click', function(){ switchTab(b.dataset.tab); });
  });

  /* ---- Boxes ---- */
  function renderBox(i) {
    var b = state.boxes[i];
    var isAir = state.method === 'air';
    var el = document.createElement('div');
    el.className = 'gc-box-row';
    el.innerHTML =
      '<div class="gc-box-header">'+
        '<span class="gc-box-label">'+T.box+' '+(i+1)+'</span>'+
        '<div class="gc-box-header-right">'+
          '<span class="gc-box-cbm-tag" id="gc-box-cbm-'+i+'">0.000 m³</span>'+
          (i > 0 ? '<button class="gc-box-remove" type="button">'+T.remove+'</button>' : '')+
        '</div>'+
      '</div>'+
      '<div class="gc-box-fields">'+
        '<div class="gc-box-field"><label>'+T.height+'</label><input type="number" class="gc-dim gc-h" min="0" step="0.1" value="'+b.h+'" placeholder="0"></div>'+
        '<div class="gc-box-field"><label>'+T.width+'</label><input type="number" class="gc-dim gc-w" min="0" step="0.1" value="'+b.w+'" placeholder="0"></div>'+
        '<div class="gc-box-field"><label>'+T.length+'</label><input type="number" class="gc-dim gc-d" min="0" step="0.1" value="'+b.d+'" placeholder="0"></div>'+
        (isAir ? '<div class="gc-box-field"><label>'+T.weight_kg+'</label><input type="number" class="gc-dim gc-wt" min="0" step="0.1" value="'+b.wt+'" placeholder="0"></div>' : '')+
      '</div>';

    el.querySelector('.gc-h').addEventListener('input', function(e){ state.boxes[i].h=e.target.value; refreshBoxCBM(i, el); });
    el.querySelector('.gc-w').addEventListener('input', function(e){ state.boxes[i].w=e.target.value; refreshBoxCBM(i, el); });
    el.querySelector('.gc-d').addEventListener('input', function(e){ state.boxes[i].d=e.target.value; refreshBoxCBM(i, el); });
    if (isAir) el.querySelector('.gc-wt').addEventListener('input', function(e){ state.boxes[i].wt=e.target.value; recalcTotals(); });
    var rem = el.querySelector('.gc-box-remove');
    if (rem) rem.addEventListener('click', function(){ state.boxes.splice(i,1); renderBoxes(); });

    /* Restore CBM display from current state (avoids reset to 0.000 on re-render) */
    var tag = el.querySelector('.gc-box-cbm-tag');
    if (tag) tag.textContent = fmtCBM(cbm(b.h, b.w, b.d));

    return el;
  }

  function refreshBoxCBM(i, el) {
    var b = state.boxes[i];
    var tag = el.querySelector('.gc-box-cbm-tag');
    if (tag) tag.textContent = fmtCBM(cbm(b.h, b.w, b.d));
    recalcTotals();
  }

  function renderBoxes() {
    var list = $id('gc-boxes-list');
    list.innerHTML = '';
    state.boxes.forEach(function(_, i){ list.appendChild(renderBox(i)); });
    recalcTotals();
  }

  $id('gc-add-box').addEventListener('click', function(){
    state.boxes.push({h:'',w:'',d:'',wt:''});
    renderBoxes();
  });

  /* ---- Totals ---- */
  function recalcTotals() {
    var totalCBM = 0, chargeableKg = 0;
    if (state.tab === 'dimensions') {
      state.boxes.forEach(function(b){
        totalCBM += cbm(b.h, b.w, b.d);
        if (state.method === 'air') chargeableKg += Math.max(parseFloat(b.wt)||0, volKg(b.h,b.w,b.d));
      });
    } else if (state.tab === 'cbm') {
      totalCBM = parseFloat($id('gc-direct-cbm').value) || 0;
    } else if (state.tab === 'weight') {
      var wt = parseFloat($id('gc-direct-weight').value) || 0;
      if (state.weightUnit === 'lb') wt *= 0.453592;
      chargeableKg = wt;
    }
    $id('gc-total-cbm').textContent       = fmtCBM(totalCBM);
    $id('gc-total-chargeable').textContent = chargeableKg.toFixed(1)+' kg';
  }

  $id('gc-direct-cbm').addEventListener('input', recalcTotals);
  $id('gc-direct-weight').addEventListener('input', recalcTotals);

  document.querySelectorAll('.gc-unit-btn').forEach(function(b){
    b.addEventListener('click', function(){
      state.weightUnit = b.dataset.unit;
      document.querySelectorAll('.gc-unit-btn').forEach(function(x){ x.classList.remove('active'); });
      b.classList.add('active');
      recalcTotals();
    });
  });

  /* ---- Disclaimer checkbox ---- */
  $id('gc-disclaimer-check').addEventListener('change', function(e){
    $id('gc-calc-btn').disabled = !e.target.checked;
  });

  /* ---- CALCULATE ---- */
  $id('gc-calc-btn').addEventListener('click', function () {
    var dest = getDestination();
    if (!dest) { alert(T.alert_destination); return; }

    var isAir = state.method === 'air';
    var totalCBM = 0, chargeableKg = 0;

    if (state.tab === 'dimensions') {
      state.boxes.forEach(function(b){
        totalCBM += cbm(b.h, b.w, b.d);
        chargeableKg += Math.max(parseFloat(b.wt)||0, volKg(b.h,b.w,b.d));
      });
    } else if (state.tab === 'cbm') {
      totalCBM = parseFloat($id('gc-direct-cbm').value) || 0;
    } else if (state.tab === 'weight') {
      var wt = parseFloat($id('gc-direct-weight').value) || 0;
      if (state.weightUnit === 'lb') wt *= 0.453592;
      chargeableKg = wt;
    }

    var qty = isAir ? chargeableKg : totalCBM;
    if (qty <= 0) { alert(T.alert_quantity); return; }

    /* ---- Check if prices are configured ---- */
    if (!isPriceConfigured(dest, state.method, qty)) {
      isErrorState = true;
      /* Store partial data so error modal email still includes what customer entered */
      calcResult = {
        method: state.method, methodName: METHOD_NAMES[state.method],
        dest, totalCBM, chargeableKg, qty,
        unit: isAir ? 'kg' : 'CBM',
        product: $id('gc-product-desc').value.trim(),
        errorState: true
      };
      $id('gc-results-panel').classList.add('gc-panel-hidden');
      var errPanel = $id('gc-error-panel');
      errPanel.classList.remove('gc-panel-hidden');
      setTimeout(function(){ errPanel.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 50);
      return;
    }

    isErrorState = false;
    $id('gc-error-panel').classList.add('gc-panel-hidden');

    /* ---- Normal calculation ---- */
    var threshold  = isAir ? cfg.airThreshold : cfg.seaThreshold;
    var rates      = isAir ? dest.air : dest.sea;
    var baseCost   = qty < threshold ? rates.costUnder : rates.costOver;
    var rate       = finalRate(baseCost, rates.margin);
    var estimated  = qty * rate;
    var unit       = isAir ? 'kg' : 'CBM';
    var transit    = isAir ? dest.air.time : dest.sea.time;
    var tierLabel  = qty < threshold
      ? '('+T.rate+' < '+threshold+' '+unit+')'
      : '('+T.rate+' ≥ '+threshold+' '+unit+')';
    var product = $id('gc-product-desc').value.trim();

    $id('gc-price-output').textContent = fmtUSD(estimated);
    $id('gc-price-detail').textContent = qty.toFixed(2)+' '+unit+' × '+fmtUSD(rate)+'/'+unit+' '+tierLabel;
    $id('gc-time-output').textContent  = transit;
    $id('gc-summary-output').innerHTML = [
      '<strong>'+T.summary_method+'</strong> '+METHOD_NAMES[state.method],
      '<strong>'+T.summary_origin+'</strong> '+T.origin_port,
      '<strong>'+T.summary_destination+'</strong> '+dest.city+', '+dest.country,
      totalCBM > 0 ? '<strong>'+T.summary_volume+'</strong> '+fmtCBM(totalCBM) : null,
      isAir && chargeableKg > 0 ? '<strong>'+T.summary_chargeable+'</strong> '+chargeableKg.toFixed(1)+' kg' : null,
      product ? '<strong>'+T.summary_goods+'</strong> '+product : null
    ].filter(Boolean).join('<br>');

    calcResult = { method: state.method, methodName: METHOD_NAMES[state.method], dest, totalCBM, chargeableKg, qty, unit, rate, estimated, transit, product, tierLabel };

    var panel = $id('gc-results-panel');
    panel.classList.remove('gc-panel-hidden');
    setTimeout(function(){ panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
  });

  /* ---- Recalculate ---- */
  $id('gc-recalculate').addEventListener('click', function(){
    $id('gc-results-panel').classList.add('gc-panel-hidden');
    $id('shipping-calculator').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---- Error panel send button ---- */
  $id('gc-error-send-btn').addEventListener('click', function(){
    $id('gc-modal-title').textContent    = T.error_modal_title;
    $id('gc-modal-subtitle').textContent = T.error_modal_subtitle;
    openModal(true);
  });

  /* ---- Modal ---- */
  function openModal(fromError) {
    $id('gc-modal-name').value  = customer.name;
    $id('gc-modal-email').value = customer.email;

    var r = calcResult;
    if (r) {
      $id('gc-modal-preview').innerHTML =
        '<div class="gc-preview-label">'+(fromError ? T.preview_pending : T.preview_summary)+'</div>'+
        '<div class="gc-preview-row"><span>'+r.methodName+'</span><span>'+(r.dest ? r.dest.city+', '+r.dest.country : '—')+'</span></div>'+
        (fromError
          ? '<div class="gc-preview-row"><span>'+T.preview_status+'</span><strong>'+T.preview_manual+'</strong></div>'
          : '<div class="gc-preview-row"><span>'+T.preview_cost+'</span><strong>'+fmtUSD(r.estimated || 0)+'</strong></div>'+
            '<div class="gc-preview-row"><span>'+T.preview_transit+'</span><span>'+r.transit+'</span></div>'
        );
    }

    $id('gc-modal-overlay').classList.remove('gc-panel-hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    $id('gc-modal-overlay').classList.add('gc-panel-hidden');
    document.body.style.overflow = '';
  }

  $id('gc-open-modal').addEventListener('click', function(){ openModal(false); });
  $id('gc-modal-close').addEventListener('click', closeModal);
  $id('gc-modal-overlay').addEventListener('click', function(e){
    if (e.target === $id('gc-modal-overlay')) closeModal();
  });

  /* ---- Phone country code selector ---- */
  var PHONE_CODES = [
    { flag: '🇺🇸', code: '+1',     name: 'EE. UU.' },
    { flag: '🇨🇴', code: '+57',    name: 'Colombia' },
    { flag: '🇪🇸', code: '+34',    name: 'España' },
    { flag: '🇦🇷', code: '+54',    name: 'Argentina' },
    { flag: '🇦🇺', code: '+61',    name: 'Australia' },
    { flag: '🇦🇹', code: '+43',    name: 'Austria' },
    { flag: '🇧🇪', code: '+32',    name: 'Bélgica' },
    { flag: '🇧🇴', code: '+591',   name: 'Bolivia' },
    { flag: '🇧🇷', code: '+55',    name: 'Brasil' },
    { flag: '🇨🇦', code: '+1',     name: 'Canadá' },
    { flag: '🇨🇱', code: '+56',    name: 'Chile' },
    { flag: '🇨🇳', code: '+86',    name: 'China' },
    { flag: '🇰🇷', code: '+82',    name: 'Corea del Sur' },
    { flag: '🇨🇷', code: '+506',   name: 'Costa Rica' },
    { flag: '🇨🇺', code: '+53',    name: 'Cuba' },
    { flag: '🇩🇰', code: '+45',    name: 'Dinamarca' },
    { flag: '🇪🇨', code: '+593',   name: 'Ecuador' },
    { flag: '🇸🇻', code: '+503',   name: 'El Salvador' },
    { flag: '🇦🇪', code: '+971',   name: 'Emiratos Árabes' },
    { flag: '🇵🇭', code: '+63',    name: 'Filipinas' },
    { flag: '🇫🇮', code: '+358',   name: 'Finlandia' },
    { flag: '🇫🇷', code: '+33',    name: 'Francia' },
    { flag: '🇩🇪', code: '+49',    name: 'Alemania' },
    { flag: '🇬🇷', code: '+30',    name: 'Grecia' },
    { flag: '🇬🇹', code: '+502',   name: 'Guatemala' },
    { flag: '🇭🇳', code: '+504',   name: 'Honduras' },
    { flag: '🇭🇰', code: '+852',   name: 'Hong Kong' },
    { flag: '🇮🇳', code: '+91',    name: 'India' },
    { flag: '🇮🇩', code: '+62',    name: 'Indonesia' },
    { flag: '🇮🇪', code: '+353',   name: 'Irlanda' },
    { flag: '🇮🇹', code: '+39',    name: 'Italia' },
    { flag: '🇯🇵', code: '+81',    name: 'Japón' },
    { flag: '🇲🇾', code: '+60',    name: 'Malasia' },
    { flag: '🇲🇽', code: '+52',    name: 'México' },
    { flag: '🇳🇮', code: '+505',   name: 'Nicaragua' },
    { flag: '🇳🇴', code: '+47',    name: 'Noruega' },
    { flag: '🇳🇿', code: '+64',    name: 'Nueva Zelanda' },
    { flag: '🇳🇱', code: '+31',    name: 'Países Bajos' },
    { flag: '🇵🇦', code: '+507',   name: 'Panamá' },
    { flag: '🇵🇾', code: '+595',   name: 'Paraguay' },
    { flag: '🇵🇪', code: '+51',    name: 'Perú' },
    { flag: '🇵🇱', code: '+48',    name: 'Polonia' },
    { flag: '🇵🇹', code: '+351',   name: 'Portugal' },
    { flag: '🇬🇧', code: '+44',    name: 'Reino Unido' },
    { flag: '🇸🇬', code: '+65',    name: 'Singapur' },
    { flag: '🇸🇪', code: '+46',    name: 'Suecia' },
    { flag: '🇨🇭', code: '+41',    name: 'Suiza' },
    { flag: '🇹🇭', code: '+66',    name: 'Tailandia' },
    { flag: '🇺🇾', code: '+598',   name: 'Uruguay' },
    { flag: '🇻🇳', code: '+84',    name: 'Vietnam' },
    { flag: '🌐',   code: '__other__', name: 'Otro' }
  ];

  /* Show country names in the visitor's language (derived from the flag's ISO code); Spanish list is the fallback */
  (function localizePhoneNames() {
    var lang = (cfg.locale || 'es').split('-')[0];
    var names = null;
    try { if (lang !== 'es' && window.Intl && Intl.DisplayNames) names = new Intl.DisplayNames([lang], { type: 'region' }); } catch (e) {}
    PHONE_CODES.forEach(function (c) {
      if (c.code === '__other__') { c.name = T.phone_other; return; }
      if (!names) return;
      var cps = Array.from(c.flag).map(function (ch) { return ch.codePointAt(0) - 127397; });
      if (cps.length !== 2) return;
      try { var n = names.of(String.fromCharCode(cps[0], cps[1])); if (n) c.name = n; } catch (e) {}
    });
  })();


  var selectedPhoneCode = PHONE_CODES[0];

  var phoneBtn        = $id('gc-phone-code-btn');
  var phoneList       = $id('gc-phone-code-list');
  var phoneDisp       = $id('gc-phone-code-display');
  var phoneCustom     = $id('gc-phone-custom-code');

  function showCustomCode() {
    phoneDisp.hidden   = true;
    phoneCustom.hidden = false;
    phoneCustom.focus();
    selectedPhoneCode = { flag: '🌐', code: phoneCustom.value.trim(), name: 'Otro' };
  }
  function hideCustomCode() {
    phoneDisp.hidden   = false;
    phoneCustom.hidden = true;
  }

  if (phoneCustom) {
    phoneCustom.addEventListener('click', function(e) { e.stopPropagation(); });
    phoneCustom.addEventListener('input', function() {
      selectedPhoneCode = { flag: '🌐', code: phoneCustom.value.trim(), name: 'Otro' };
    });
  }

  if (phoneBtn && phoneList) {
    PHONE_CODES.forEach(function (c, i) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.dataset.index = i;
      var displayCode = c.code === '__other__' ? '' : c.code;
      li.innerHTML = '<span class="gc-phone-code-flag">' + c.flag + '</span>'
        + '<span class="gc-phone-code-name">' + c.name + '</span>'
        + (displayCode ? '<span class="gc-phone-code-num">' + displayCode + '</span>' : '');
      if (i === 0) li.classList.add('is-selected');
      li.addEventListener('click', function () {
        phoneList.querySelectorAll('li').forEach(function(x){ x.classList.remove('is-selected'); });
        li.classList.add('is-selected');
        closePhoneList();
        if (c.code === '__other__') {
          showCustomCode();
        } else {
          hideCustomCode();
          selectedPhoneCode = c;
          phoneDisp.textContent = c.flag + ' ' + c.code;
          $id('gc-modal-phone').focus();
        }
      });
      phoneList.appendChild(li);
    });

    phoneBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = !phoneList.hidden;
      if (open) { closePhoneList(); } else { openPhoneList(); }
    });

    document.addEventListener('click', function () { closePhoneList(); });
    phoneList.addEventListener('click', function (e) { e.stopPropagation(); });
  }

  function openPhoneList() {
    phoneList.hidden = false;
    phoneBtn.setAttribute('aria-expanded', 'true');
  }
  function closePhoneList() {
    phoneList.hidden = true;
    phoneBtn.setAttribute('aria-expanded', 'false');
  }

  /* ---- Build email body + AJAX submit ---- */
  $id('gc-quotation-form').addEventListener('submit', function(e){
    e.preventDefault();
    var form    = this;
    var r       = calcResult || {};
    var extra   = $id('gc-modal-extra').value.trim() || '';
    var modName = $id('gc-modal-name').value.trim()  || customer.name;
    var modMail = $id('gc-modal-email').value.trim() || customer.email;
    var phoneNum = $id('gc-modal-phone').value.trim();
    var codeStr  = selectedPhoneCode.code === '__other__'
      ? ($id('gc-phone-custom-code').value.trim() || '+?')
      : selectedPhoneCode.code;
    var modTel   = phoneNum ? (codeStr + ' ' + phoneNum) : '—';
    var recip   = cfg.recipientEmail || '';
    var now     = new Date().toLocaleString('es-VE', { dateStyle: 'long', timeStyle: 'short' });

    function pad(s, n) { s = String(s); while (s.length < n) s += ' '; return s; }
    function row(label, value) { return '  ' + pad(label, 26) + (value || '—'); }

    var lines = [
      '╔══════════════════════════════════════════════════════════╗',
      '║         SOLICITUD DE COTIZACIÓN — GALIUM CARGO           ║',
      '╚══════════════════════════════════════════════════════════╝',
      '',
      recip ? '► REENVIAR A: ' + recip : '',
      recip ? '' : '',
      '┌─ DATOS DEL CLIENTE ─────────────────────────────────────┐',
      row('Nombre completo:', modName),
      row('Correo electrónico:', modMail),
      row('Teléfono / WhatsApp:', modTel),
      row('Fecha de solicitud:', now),
      '└─────────────────────────────────────────────────────────┘',
      '',
      '┌─ DETALLES DEL ENVÍO ────────────────────────────────────┐',
      row('Método de envío:', METHOD_NAMES_ES[r.method] || '—'),
      row('Origen:', 'Puerto de Guangdong, China'),
      r.dest ? row('Destino:', r.dest.city + ', ' + r.dest.country) : '',
      r.totalCBM   > 0 ? row('Volumen total:', r.totalCBM.toFixed(3) + ' m³')       : '',
      r.chargeableKg > 0 ? row('Peso facturable:', r.chargeableKg.toFixed(1) + ' kg') : '',
      row('Mercancía:', r.product || 'No especificada'),
      '└─────────────────────────────────────────────────────────┘',
      '',
    ];

    if (r.errorState) {
      lines.push('┌─ ESTADO DE COTIZACIÓN ──────────────────────────────────┐');
      lines.push('  ⚠  REQUIERE COTIZACIÓN MANUAL');
      lines.push('  Las tarifas para esta ruta no están configuradas.');
      lines.push('  Por favor preparar cotización personalizada para el cliente.');
      lines.push('└─────────────────────────────────────────────────────────┘');
    } else {
      lines.push('┌─ RESULTADO DE COTIZACIÓN ESTIMADA ──────────────────────┐');
      lines.push(row('Costo estimado de flete:', fmtUSD(r.estimated || 0)));
      lines.push(row('Tarifa aplicada:', (r.rate > 0 ? fmtUSD(r.rate) + '/' + r.unit + ' ' + (r.tierLabel || '') : '—')));
      lines.push(row('Tiempo de tránsito estimado:', r.transit || '—'));
      lines.push('└─────────────────────────────────────────────────────────┘');
    }

    if (extra) {
      lines.push('');
      lines.push('┌─ INFORMACIÓN ADICIONAL DEL CLIENTE ─────────────────────┐');
      lines.push('  ' + extra.replace(/\n/g, '\n  '));
      lines.push('└─────────────────────────────────────────────────────────┘');
    }

    lines.push('');
    lines.push('─────────────────────────────────────────────────────────────');
    lines.push('Estimación referencial. Precio final confirmado al formalizar');
    lines.push('la operación con Galium Cargo.');

    $id('gc-form-body').value = lines.filter(function(l){ return l !== null; }).join('\n');

    /* Submit via fetch and show confirmation */
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = T.sending; }

    var fd = new FormData(form);
    fetch(form.action, { method: 'POST', body: fd, redirect: 'manual' })
      .catch(function(){})
      .finally(function () {
        form.classList.add('gc-panel-hidden');
        document.querySelector('.gc-modal-header').style.display = 'none';
        $id('gc-modal-success').classList.remove('gc-panel-hidden');
      });
  });

  /* Success close button */
  $id('gc-modal-success-close').addEventListener('click', function () {
    closeModal();
    /* Reset success state for next use */
    setTimeout(function () {
      $id('gc-modal-success').classList.add('gc-panel-hidden');
      document.querySelector('.gc-modal-header').style.display = '';
      var form = $id('gc-quotation-form');
      form.classList.remove('gc-panel-hidden');
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = T.send + ' <svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>'; }
    }, 400);
  });

  /* ---- Init ---- */
  renderDests();
  setMethod('sea');
  renderBoxes();

}());

